import type React from "react";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Container, Content } from "./styles";

interface Props {
  enrollments?: number;
}

export const EnrolledPatientsSE: React.FC<Props> = ({ enrollments }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <Typography variant="h3">{t("earnings_widget.enrolled_patients.title")}:</Typography>
        <Value>{enrollments}</Value>
      </Content>
    </Container>
  );
};

const Value = styled.span`
  margin-left: 8px;
  font-size: 22px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.redesign.b100};
  background: ${({ theme }) => theme.colors.redesign.b10};
  padding: 4px 8px;
  border-radius: 4px;
`;
